import { appLog } from '@shared/common/logging/app-log.util';
import { Component, Input, OnInit } from '@angular/core';
import { UserDetailsDto } from '@shared/service-proxies/service-proxies';
@Component({
    standalone: false,
    selector: "single-user-image",
    templateUrl: "./single-user-image.component.html",
    styleUrls: ["./single-user-image.component.scss"],
})
export class SingleUserImageComponent implements OnInit {
    constructor() { }
    @Input()
    user: UserDetailsDto;
    @Input()
    size: string;
    ngOnInit(): void {
        appLog.log("User Details: ", this.user);
        if (!this.user) {
            this.user = new UserDetailsDto();
        }
    }
}
